/**
 * The only analytics the free risk matrix calculator sends. Every property is
 * a fixed value, so the scores a visitor picks never reach PostHog; pinned by
 * __tests__/marketing/risk-matrix-behaviour.test.tsx.
 */
export type RiskMatrixEvent =
  /** The visitor picked a score for the first time on this page view. */
  | { event: "risk_matrix_used" }
  /** The visitor completed a before-controls rating and saw a result. */
  | { event: "risk_matrix_completed" };

interface Capture {
  capture?: (event: string, properties: Record<string, string>) => unknown;
}

export function trackRiskMatrix(posthog: Capture | null | undefined, analyticsEvent: RiskMatrixEvent): void {
  posthog?.capture?.(analyticsEvent.event, { tool: "risk_matrix" });
}
